<template>
  <div class="vehicle-drilldown">
    <div
      v-show="selectedVehicle.full_name"
      id="vehicle-drilldown-back"
      class="row"
    >
      <div class="col-12 col-lg-10">
        <p>
          <strong>{{ your_vehicle_is_set_to }}: </strong
          >{{ selectedVehicle.full_name }}
        </p>
      </div>

      <div id="vehicle-drilldown-back-back" class="col-12 col-lg-2">
        <a
          :href="changeUrl"
          class="btn btn-hover btn-primary"
          >{{ label_back }}</a
        >
      </div>
    </div>

    <!-- <div class="change-vehicle" v-if="selectedVehicle.full_name">

         <a :href="fullUrl + '?type_id=' + url_query" class="full-button btn btn-hover btn-primary" v-if="url_query">{{ label_change_vehicle }}</a>
    </div> -->

    <div class="form" v-if="!selectedVehicle.full_name">
      <div class="form-content">
        <!-- <h3>Select Your Vehicle</h3> -->
        <div
          class="check-rego"
          v-show="enable_rego_lookup == 'yes' || showVehicles"
        >
          <!-- <h4>Search By Rego or
            <a href="#" v-on:click.self.prevent="showVehicles = true;">Search By Vehicle</a>
          </h4> -->
          <h2>SELECT YOUR VEHICLE</h2>
          <h4>
            Fill in your vehicle registration to prepopulate or choose manually
          </h4>
          <div class="form-row rego-fields">
            <div class="select-state">
              <label for>Select your state</label>
              <select v-model="state" dusk="State" id="State" @change="triggerGA">
                <option value="" disabled>{{ label_select }}</option>
                <option value="ACT" dusk="ACT">ACT</option>
                <option value="NSW" dusk="NSW">NSW</option>
                <option value="NT"  dusk="NT">NT</option>
                <option value="Qld" dusk="Qld">QLD</option>
                <option value="SA"  dusk="SA">SA</option>
                <option value="Vic" dusk="Vic">VIC</option>
                <option value="Tas" dusk="Tas">TAS</option>
                <option value="WA"  dusk="WA">WA</option>
              </select>
            </div>

            <div class="rego-number" v-show="state">
              <label for>Registration details below</label>
              <div class="rego-input">
                <input
                  type="text"
                  v-model="rego"
                  placeholder="ENTER - REGO"
                  v-on:keyup.enter="getRegoDetails()"
                />
                <button
                  id="vehicle-drill-down-find-my-car "
                  :disabled="rego.length == 0"
                  @click="getRegoDetails()"
                  class="btn arrow-btn"
                >
                  <i class="icon icon-right"></i>
                </button>
              </div>
            </div>

            <!-- <div
              class="form-row"
              v-if="
                state == 'ACT' ||
                state == 'NT' ||
                state == 'Qld' ||
                state == 'SA' ||
                state == 'Vic' ||
                state == 'Tas'
              "
            >
              <span
                >Sorry! unavailable in your state, Please proceed manually</span
              >
            </div> -->

            <span v-if="showRegoNotFound" v-html="showRegoNotFoundMsg"></span>
          </div>

          <!-- <div class="form-row">
              <button id="vehicle-drill-down-find-my-car" @click="getRegoDetails()" class="btn btn-hover btn-primary">Find My Car</button>
          </div> -->
        </div>
        <div>
          <!-- <h4 v-show="enable_rego_lookup == 'yes'" style="float: right"><button  class="btn btn-hover btn-primary" v-on:click.self.prevent="showVehicles = false;">{{ label_back }}</button></h4> -->
          <div class="form-row">
            <a v-if="enableShareLink" @click.prevent="showTheSharePrompt" target="_blank" :href="vehicleShareLink" class="share-link">
              <small>SHARE</small>
            </a>
            <label for>{{ label_manufacturer }}</label>
            <select
              name
              :id="label_manufacturer"
              v-model="manufacturerId"
              dusk="Manufacturer"
              @change="triggerGA"
            >
            <option value="0" disabled>{{ label_select }}</option>
              <optgroup label="- Popular Makes -" v-if="popularManufacturers && popularManufacturers.length > 0">
                   <option
                    v-for="(popularManufacturer, index) in popularManufacturers"
                    :key="index"
                    :id="popularManufacturer.manufacturerId"
                    :value="popularManufacturer.manufacturerId"
                    :dusk="popularManufacturer.title"
                     >
                    {{ popularManufacturer.title }}
                  </option>
              </optgroup>
              <optgroup :label="getAllMakesLabel">
                  <option
                    v-for="(manufacturer, index) in manufacturers"
                    :key="index"
                    :id="manufacturer.manufacturerId"
                    :value="manufacturer.manufacturerId"
                    :dusk="manufacturer.title"
                     >
                    {{ manufacturer.title }}
                  </option>
              </optgroup>


            </select>
          </div>

          <div class="form-row">
            <label for>{{ label_model }} </label>
            <select
              name
              :id="label_model"
              v-model="modelId"
              :disabled="models.length == 0"
              dusk="Model"
              @change="triggerGA"
            >
              <option value="0" disabled>{{ label_select }}</option>
              <optgroup label="- Popular Models -" v-if="popularModels && popularModels.length > 0">
                   <option
                    v-for="(popularModel, index) in popularModels"
                    :key="index"
                    :id="popularModel.modelId"
                    :value="popularModel.modelId"
                    :dusk="popularModel.title"
                     >
                    {{ popularModel.title }}
                  </option>
              </optgroup>
              <optgroup :label="getAllModelsLabel">
                <option
                  v-for="(model, index) in models"
                  :key="index"
                  :id="model.modelId"
                  :value="model.modelId"
                  :dusk="model.title"
                >
                  {{ model.title }}
                </option>
              </optgroup>
            </select>
          </div>

          <div class="form-row row">
            <div class="col-12 col-lg-6">
              <label for>{{ label_year }}</label>
              <select
                name
                :id="label_year"
                v-model="year"
                :disabled="years.length == 0"
                dusk="Year"
                @change="triggerGA"
              >
                <option value="0" disabled>{{ label_select }}</option>
                <option
                  v-for="(year, index) in years"
                  :key="index"
                  :value="year"
                  :dusk="'year_' + year"
                >
                  {{ year }}
                </option>
              </select>
            </div>
            <div class="col-12 col-lg-6 body-type-select">
              <label for> {{ label_body_type }}</label>
              <select
                name
                id="body_type"
                v-model="bodyTypeId"
                :disabled="bodyTypes.length == 0"
                dusk="body_type"
                @change="triggerGA"
              >
                <option value="0" disabled>{{ label_select }}</option>
                <option
                  v-for="(bodyType, index) in bodyTypes"
                  :key="index"
                  :value="bodyType.bodyTypeId"
                  :dusk="'body_type_' + bodyType.title"
                >
                  {{ bodyType.title }}
                </option>
              </select>
            </div>
          </div>

          <div class="vehicle-selection" v-show="vehicles.length > 0">
            <p>{{ label_is_this_your_vehicle }}</p>
            <div
              v-for="(vehicle, index) in vehicles"
              :key="index"
              class="row vehicle-selection-row"
            >
              <div class="col-10 col-lg-11">
                <label :for="vehicle.Vehicle.vehicleId" class="vehicle-label">{{
                  vehicle.Vehicle.full_name
                }}</label>
              </div>

              <div class="col-2 col-lg-1 vehicle-select-div">
                <input
                  type="radio"
                  :id="vehicle.Vehicle.vehicleId"
                  name="vehicleId"
                  :value="vehicle.Vehicle"
                  v-model="newSelectedVehicle"
                  :dusk="'vehicle_' + vehicle.Vehicle.full_name"
                  class="vehicle_select_radio"
                  @change="triggerGA"
                />
              </div>
            </div>

             <h5 class="regoDetailsSuccess" v-if="regoDetailsSuccessMsg">Please check carefully that the vehicle description above matches your model.</h5>

            <button
              id="select_vehicle"
              dusk="select_vehicle"
              class="btn btn-hover btn-primary"
              @click="selectVehicle()"
              :disabled="!newSelectedVehicle"
            >
              {{ label_select_vehicle }}
            </button>
          </div>

          <div class="overlay" v-show="loading" dusk="loading_overlay">
            <p class="loading">
              <img src="/cdn/images/loading.gif" width="100" />
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sortPopularList from "../../../mixins/sortPopularList";

export default {
  name: "vehicle-drilldown",
  mixins: [sortPopularList],
  props: {
    selectedVehicle: {
      type: Object,
    },
    link: {
      type: String,
    },
    label_manufacturer: {
      type: String,
      default: "Manufacturer",
    },
    label_model: {
      type: String,
      default: "Model",
    },
    label_year: {
      type: String,
      default: "Year",
    },
    label_body_type: {
      type: String,
      default: "Body Type",
    },
    label_loading: {
      type: String,
      default: "Loading",
    },
    label_select: {
      type: String,
      default: "Select",
    },
    label_select_vehicle: {
      type: String,
      default: "Select Vehicle",
    },
    label_is_this_your_vehicle: {
      type: String,
      default: "Is this your vehicle?",
    },
    your_vehicle_is_set_to: {
      type: String,
      default: "Your vehicle is set to",
    },
    label_change_vehicle: {
      type: String,
      default: "Change Vehicle",
    },
    enable_rego_lookup: {
      type: String,
      default: "false",
    },
    label_back: {
      type: String,
      default: "Back",
    },
    solution: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      manufacturers: [],
      manufacturerId: 0,
      models: [],
      modelId: 0,
      years: [],
      year: 0,
      bodyTypes: [],
      bodyTypeId: 0,
      vehicles: [],
      loading: true,
      newSelectedVehicle: null,
      url_query: "",
      rego: "",
      state: "",
      maintain: false,
      showVehicles: false,
      showRegoNotFound: false,
      showRegoNotFoundMsg:
        "Sorry, no vehicle match found for that registration.<br/>Please try searching for your vehicle from<br/>the dropdown options below.",
      regoDetailsSuccess: false,
      regoDetailsSuccessMsg: false,
      urlParams: {
        // manufacturerId: '',
        // modelId: '',
      },
      loadVehicleOptionsFromUrl: false,
      enableShareLink: false,
    };
  },
  computed: {
    fullUrl() {
      return `/${window.culture}/${this.link}`;
    },
    changeUrl() {
      return this.fullUrl + '?change';
    },
    selectedVehicleModel: {
      get: function () {
        return this.selectedVehicle;
      },
      set: function (vehicle) {
        this.newSelectedVehicle = vehicle;
      },
    },
    popularManufacturers() {
      return this.isRoofJourney ? this.sortPopularList(this.manufacturers) : [];
    },
    popularModels() {
      return this.isRoofJourney ? this.sortPopularList(this.models) : [];
    },
    isRoofJourney() {
      // if there is no vehicle type, it's roof journey
      // return location.search.indexOf('type_id') > -1 ? false : true;
      return ((this.solution.solution_type == 'roof') && (this.solution.vehicle_type == null)) ? true : false;
    },
    getAllMakesLabel() {
      if(this.isRoofJourney && this.popularManufacturers && this.popularManufacturers.length > 0) {
        return '- All Makes -';
      }
      return '';
    },
    getAllModelsLabel() {
      if(this.isRoofJourney && this.popularModels && this.popularModels.length > 0) {
        return '- All Models -';
      }
      return '';
    },
    vehicleShareLink() {
      return window.location.href + '?' +  new URLSearchParams(this.urlParams).toString();
    }

  },
  mounted() {

    // this.url_query = this.getUrlParameter("type_id");
    this.url_query = this.solution.vehicle_type;

    this.loadVehicleOptionsFromUrl = this.isParamInURL('manufacturer');

    if ((this.$store.state.solutions.selectedCulture !== window.culture) || this.loadVehicleOptionsFromUrl ) {
      this.$store.commit('solutions/resetSelectedHistory');
    }

    this.getVehicleManufacturers();

    if (this.loadVehicleOptionsFromUrl) {
      this.useURLParams();
    }

    if (this.url_query) {
      this.resetVehicle();
    }
  },
  methods: {
    async getRegoDetails() {

       this.regoDetailsSuccess = false;
       this.regoDetailsSuccessMsg = false;
       this.newSelectedVehicle = null;


      if (this.rego.length > 1) {

        this.loading = true;

        this.manufacturerId = 0;
        this.modelId = 0;
        this.year = 0;
        this.bodyTypeId = 0;

        try {
          var response = await axios.get(
          "api/solutions/rego?rego=" + this.rego + "&state=" + this.state
        );

        } catch(err){
          this.loading = false;
          this.showRegoNotFound = true;
        }

        this.maintain = true;
        this.showRegoNotFound = false;

        if (response && response.data.data && response.data.success) {
          if (response.data.data.manufacturer) {
            this.manufacturerId = response.data.data.manufacturer;
            if (response.data.data.model) {
              this.modelId = response.data.data.model;
              if (response.data.data.year) {
                this.year = response.data.data.year;
                if (response.data.data.body) {
                  this.bodyTypeId = response.data.data.body;
                  this.regoDetailsSuccess = true;
                }
              }
            }
          }
        } else {
          this.showRegoNotFound = true;
        }
        this.showVehicles = true;

           this.loading = false;
        setTimeout(() => {
          this.maintain = false;
        }, 2000);
      }
    },
    resetVehicle() {
      this.$emit("selectVehicle", {});
      if (!this.loadVehicleOptionsFromUrl) {
        this.manufacturerId = 0;
      }
    },
    selectVehicle() {
      this.$emit("selectVehicle", this.newSelectedVehicle);
    },
    async getVehicleManufacturers() {
      let response;
      if (this.url_query)
        response = await axios.get(
          "api/vehicle/makes?type_id=" + this.url_query
        );
      else response = await axios.get("api/vehicle/makes");

      this.manufacturers = response.data.data;

      if (this.$store.state.solutions.manufacturersCount && this.$store.state.solutions.manufacturersCount != this.manufacturers.length) {
        this.$store.commit('solutions/resetSelectedHistory');
        this.resetVehicle();
      }

      this.loading = false;

      if (this.$store.state.solutions.selectedManufacturerId) {
        this.manufacturerId = this.$store.state.solutions.selectedManufacturerId;
      }

      this.$store.commit('solutions/storeManufacturersCount', this.manufacturers.length ?? null);
      this.$store.commit('solutions/storeCulture', window.culture);
    },
    getUrlParameter(name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      var results = regex.exec(location.search);
      return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
    },
    hasBodyType(){
      return this.bodyTypes.some(bodyType => bodyType.bodyTypeId == this.bodyTypeId);
    },
    triggerGA(event) {
      this.regoDetailsSuccess = false
      if(event.target.tagName === 'SELECT'){
        let selectedValue = event.target.options[event.target.selectedIndex].getAttribute('dusk');
        let inputName = event.target.id;
        ga('send','event', 'Fit My Vehicle', inputName ,selectedValue);
            gtag('event', 'fit_my_vehicle', {'category': 'Fit My Vehicle', 'action':inputName, value:selectedValue});
      } else if(event.target.tagName === 'INPUT') {
        ga('send','event', 'Fit My Vehicle', 'Selected Vehicle', this.newSelectedVehicle.full_name);
            gtag('event', 'fit_my_vehicle', {'category': 'Fit My Vehicle', 'action':'Selected Vehicle', value:this.newSelectedVehicle.full_name});
      }
    },
    updateUrlParam(paramName,  paramValue) {
      this.$set(this.urlParams, paramName, paramValue);
      // window.history.replaceState({}, null,  window.location.pathname + '?' + this.getVehicleParams) ;
    },
    isParamInURL(param) {
        return window.location.search.indexOf(param) > -1;
    },
    useURLParams() {
      if (this.isParamInURL('manufacturer')) {
        let manufacturerId = this.getUrlParameter('manufacturer');
        let modelId = this.getUrlParameter('model');

          if (manufacturerId) {
            this.updateUrlParam('manufacturer', manufacturerId);
            this.manufacturerId = manufacturerId;
          }

          if (modelId) {
            this.updateUrlParam('model', modelId);
          }
      }
    },
    hideUrlParams() {
        window.history.replaceState({}, null,  window.location.pathname);
    },
    showTheSharePrompt() {
      prompt('Please copy the link bellow (Ctrl/Cmd + C): ', this.vehicleShareLink);
    }
  },
  watch: {
    async manufacturerId() {

      if (!this.maintain) {
        this.modelId = 0;
      }

      this.updateUrlParam('manufacturer', this.manufacturerId);
      this.enableShareLink = true;
      this.$store.commit('solutions/storeManufacturerId', this.manufacturerId);


      this.loading = true;
       this.regoDetailsSuccessMsg = false;
      try {
        let url;
        if (this.url_query)
          url =
            `api/vehicle/models/${this.manufacturerId}` +
            "?type_id=" +
            this.url_query;
        else url = `api/vehicle/models/${this.manufacturerId}`;

        let response = await axios.get(url);

        this.models = response.data.data;

        if (this.isParamInURL('model')) {
          this.modelId = this.getUrlParameter('model');
        } else if (this.models.length == 1) {
          this.modelId = this.models[0].modelId;
        } else if (this.$store.state.solutions.selectedModelId) {
          this.modelId = this.$store.state.solutions.selectedModelId;
        }

        this.loading = false;

      } catch (err) {
        console.error(err);
      }
    },
    async modelId() {
      if (!this.maintain) {
        this.year = 0;
      }

      this.updateUrlParam('model', this.modelId);
      this.hideUrlParams();

      this.$store.commit('solutions/storeModelId', this.modelId);
      this.loading = true;
      this.regoDetailsSuccessMsg = false;
      try {
        let url;
        if (this.url_query)
          url =
            `api/vehicle/model/years/${this.modelId}` +
            "?type_id=" +
            this.url_query;
        else url = `api/vehicle/model/years/${this.modelId}`;

        let response = await axios.get(url);
        this.years = response.data.data;
        if (this.years.length == 1) {
          this.year = this.years[0];
        } else if (this.$store.state.solutions.selectedYear) {
          this.year = this.$store.state.solutions.selectedYear;
        }
        this.loading = false;
      } catch (err) {}
    },
    async year() {
      if (!this.maintain) {
        this.bodyTypeId = 0;
      }
      this.$store.commit('solutions/storeYear', this.year);
      this.loading = true;
      this.regoDetailsSuccessMsg = false;
      try {
        let url;
        if (this.url_query)
          url =
            `api/vehicle/model/body-types/${this.modelId}/${this.year}` +
            "?type_id=" +
            this.url_query;
        else url = `api/vehicle/model/body-types/${this.modelId}/${this.year}`;
        let response = await axios.get(url);
        this.bodyTypes = response.data.data;
        if (this.bodyTypes.length == 1) {
          this.bodyTypeId = this.bodyTypes[0].bodyTypeId;
        } else if (this.$store.state.solutions.selectedBodyTypeId) {
          this.bodyTypeId = this.$store.state.solutions.selectedBodyTypeId;
        }

       if(this.regoDetailsSuccess){
         if(!this.hasBodyType()){
           this.showRegoNotFound = true;
         }else{
           this.regoDetailsSuccessMsg = true;
         }
       }
      this.loading = false;
      } catch (err) {}
    },
    async bodyTypeId() {
      this.loading = true;
      this.$store.commit('solutions/storeBodyTypeId', this.bodyTypeId);
      try {
        let url;
        if (this.url_query)
          url =
            `api/vehicle/retrieve/${this.modelId}/${this.year}/${this.bodyTypeId}` +
            "?type_id=" +
            this.url_query;
        else
          url = `api/vehicle/retrieve/${this.modelId}/${this.year}/${this.bodyTypeId}`;
        let response = await axios.get(url);
        this.vehicles = response.data.data;
        // if (this.vehicles.length == 1) {
        //   this.newSelectedVehicle = this.vehicles[0].Vehicle;
        // }
        this.loading = false;
      } catch (err) {}
    },
  },
};
</script>
<style lang="scss" scoped>
.regoDetailsSuccess {
    font-weight: bold;
    margin-top: 50px;

}
.vehicles-history {
  @media screen and (max-width: 768px) {
      padding-left: 15px;
      padding-right: 15px;
  }
  label {
    font-family:'trim-medium';
  }
  select {
    appearance: none;
    padding: 10px 15px;
    border-radius: 0;
    border: 1px solid #eaeaea;
    color: #212529;
    background-repeat: no-repeat;
    background-color: white;
    width: 100%;
    margin-bottom: 1rem;
  }
}
.vehicle-label {
  cursor:pointer;
  display:block;
  width: 100%;
}
@media screen and (max-width: 768px) {
  .body-type-select {
    margin-top:1rem;
  }
}
.share-link {
  position:absolute;
  right:0
}

</style>
